import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import { setItem } from '@/utils/storage-main.js'
import api from '@/http/api.js'
import { getBusinessType } from '@/constant'
Vue.use(Vuex)
export default new Vuex.Store({
  modules,
  state: {
    isMobile: false,
    jwt: null,
    eventData: null,
    regional: '', // 默认为空（默认值不可变更），为空时请求接口； 0 = 中国大陆 1 = 海外
    currentAccount: '',
    containerHoverStatus: '',
    cardUser: '',
    isDialog: false, // 游客是否pc显示弹窗
    isMobileDialog: false, // 游客是否移动端显示弹窗
    userinfo: null,
    isBinded: true,
    smsLength: 4, // 短信验证码长度
    activeSms:false, // 发送短信验证码按钮颜色
    loginResultData: null // 登录结果返回数据（hr绑定员工页用）
  },
  getters: {
    cardUser: (state) => {
      return state.cardUser
    },
    loginResultData: (state) => {
      return state.loginResultData
    },
    // 活动信息
    eventData: (state) => {
      return state.eventData
    },
    // 地域
    regional: (state) => {
      return state.regional
    },
    currentAccount: (state) => {
      return state.currentAccount
    },
    containerHoverStatus: (state) => {
      return state.containerHoverStatus
    },
    userInfo: (state) => {
      return state.userinfo
    },
    isActive: (state) => {
      return state.activeSms
    }
  },
  mutations: {
    setContainerHoverStatus(state, val) {
      state.containerHoverStatus = val
    },
    setLoginResultData(state, val) {
      state.loginResultData = val
    },
    setCurrentAccount(state, val) {
      state.currentAccount = val
    },
    //存储event数据
    setEventData(state, val) {
      state.eventData = val
    },
    setRegional(state, val) {
      state.regional = val
    },
    setState(state, object) {
      for (let key in object) state[key] = object[key]
    },
    setCardUser(state, val) {
      state.cardUser = val
    },
    clearUserData(state) {
      state.jwt = null
      state.user = null
    },
    setIsDialog(state) {
      state.isDialog = state
    },
    setIsMobileModel(state) {
      state.isMobileDialog = state
    },
    SET_USERINFO(state, userinfo) {
      const { hash } = userinfo.data.properties
      state.userinfo = userinfo
      setItem('userhash', hash)
    },
    SET_BINDERROR(state, error) {
      state.isBinded = error
    },
    SET_SMSISACTIVE(state, isActive) {
      state.activeSms = isActive
    }
  },
  actions: {
    async getUserInfo({ commit }) {
      try {
        const userinfo = await api.login.GetUserInfo()
        commit('SET_USERINFO', userinfo)
      } catch (error) {
        throw error
      }
    },
    async userLogin({ commit }, params) {
      try {
        return await api.login.UserLogin(params)
      } catch (error) {
        throw error
      }
    },
    async userSmsLogin({ commit }, params) {
      try {
        return await api.login.VerificationCodeLogin(params)
      } catch (error) {
        throw error
      }
    },
    async BindPhone({ commit }, params) {
      try {
        return await api.login.BindPhone(params)
      } catch (error) {
        throw error
      }
    },
    async BindEmail({ commit }, params) {
      try {
        return await api.login.BindEmail(params)
      } catch (error) {
        throw error
      }
    },
    async BindUser({ commit }, params, gi_guest) {
      try {
        return await api.login.BindUser(params, gi_guest)
      } catch (error) {
        throw error
      }
    },
    async RegisterByEmail({ commit }, params) {
      try {
        return await api.login.RegisterByEmail(params)
      } catch (error) {
        throw error
      }
    },
    async RegisterByPhone({ commit }, params) {
      try {
        return await api.login.RegisterByPhone(params)
      } catch (error) {
        throw error
      }
    },
    async CheckUser({ commit }, params) {
      try {
        params.source = getBusinessType().id
        return await api.login.CheckUser(params)
      } catch (error) {
        throw error
      }
    },
    async GetAuthCode({ commit }, params,gi_guest) {
      try {
        return await api.login.GetAuthCode(params, gi_guest)
      } catch (error) {
        throw error
      }
    },
    async CheckProtocal({ commit }) {
      try {
        return await api.user.checkUserProto()
      } catch (error) {
        throw error
      }
    },
    async getWhiteList({ commit }) {
      try {
        return await api.user.getWhiteList()
      } catch (error) {
        throw error
      }
    },
    async ThirdLogin({ commit }, params) {
      try {
        return await api.login.ThirdLogin(params)
      } catch (error) {
        throw error
      }
    },
    async getUserExtraInfo({ commit }, params) {
      try {
        return await api.user.getUserExtraInfo(params)
      } catch (error) {
        throw error
      }
    },
    async getAiaOrganList({ commit }) {
      try {
        return await api.user.getAiaOrganList()
      } catch (error) {
        throw error
      }
    },
    async setSaveExtraInfo({ commit }, params) {
      try {
        return await api.user.setSaveExtraInfo(params)
      } catch (error) {
        throw error
      }
    },
  },
  strict: process.env.NODE_ENV !== 'production',
})
